"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
global.Decimal = global.Decimal || require("decimal.js").default;
exports.default = global.Decimal;
//console.log("core/decimal", Decimal)
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9kZWNpbWFsLmpzIl0sIm5hbWVzIjpbImdsb2JhbCIsIkRlY2ltYWwiLCJyZXF1aXJlIiwiZGVmYXVsdCJdLCJtYXBwaW5ncyI6Ijs7Ozs7QUFBQUEsT0FBT0MsT0FBUCxHQUFpQkQsT0FBT0MsT0FBUCxJQUFrQkMsUUFBUSxZQUFSLEVBQXNCQyxPQUF6RDtrQkFDZUgsT0FBT0MsTztBQUN0QiIsImZpbGUiOiJkZWNpbWFsLmpzIiwic291cmNlc0NvbnRlbnQiOlsiZ2xvYmFsLkRlY2ltYWwgPSBnbG9iYWwuRGVjaW1hbCB8fCByZXF1aXJlKFwiZGVjaW1hbC5qc1wiKS5kZWZhdWx0XG5leHBvcnQgZGVmYXVsdCBnbG9iYWwuRGVjaW1hbFxuLy9jb25zb2xlLmxvZyhcImNvcmUvZGVjaW1hbFwiLCBEZWNpbWFsKVxuIl19


//////////////////
// WEBPACK FOOTER
// ../core/lib/decimal.js
// module id = 93
// module chunks = 0